import React from 'react';

const Error = () => {
    return (
        <div>
            <h1>
                In valid input
                <p><big>404 error</big></p>
            </h1>
        </div>
    );
};

export default Error;